/// <reference path="convertFunctionToEs6Class.ts" />
